import React from 'react';
import { FireOutlined, ReloadOutlined, StarOutlined, MessageOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

// Cores dos tipos de campanha
export const getKindColor = (kind) => {
  switch (kind) {
    case 'offer':
      return 'error';
    case 'reactivation':
      return 'processing';
    case 'activation':
      return 'success';
    case 'follow_up':
      return 'warning';
    default:
      return 'default';
  }
};

// Labels dos tipos de campanha
export const getKindLabel = (kind) => {
  const translations = {
    'offer': 'Oferta',
    'reactivation': 'Reativação',
    'activation': 'Ativação',
    'follow_up': 'Follow Up'
  };
  
  return translations[kind] || kind;
};

// Ícones dos tipos de campanha
export const getKindIcon = (kind) => {
  switch (kind) {
    case 'offer':
      return <FireOutlined style={{ color: '#ff4d4f' }} />;
    case 'reactivation':
      return <ReloadOutlined style={{ color: '#1890ff' }} />;
    case 'activation':
      return <StarOutlined style={{ color: '#52c41a' }} />;
    case 'follow_up':
      return <MessageOutlined style={{ color: '#faad14' }} />;
    default:
      return null;
  }
};

// Cores dos status das mensagens
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'scheduled':
      return 'purple';
    case 'sent':
      return 'processing';
    case 'delivered':
      return 'success';
    case 'read':
      return 'success';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
};

// Labels dos status das mensagens
export const getStatusLabel = (status) => {
  const translations = {
    'pending': 'Pendente',
    'scheduled': 'Agendado',
    'sent': 'Enviado',
    'delivered': 'Entregue',
    'read': 'Lido',
    'failed': 'Falha'
  };

  return translations[status] || status;
};

// Descrições dos tipos de campanha
export const getKindDescription = (kind) => {
  const descriptions = {
    'offer': 'Campanha de ofertas e promoções para produtos específicos',
    'reactivation': 'Campanha para reativar clientes que não compram há um tempo',
    'activation': 'Campanha de boas-vindas para novos clientes',
    'follow_up': 'Campanha de acompanhamento personalizado'
  };
  
  return descriptions[kind] || '';
};

// Tag completa com ícone, cor e label
export const getKindTag = (kind) => {
  return (
    <Tag color={getKindColor(kind)} icon={getKindIcon(kind)}>
      {getKindLabel(kind)}
    </Tag>
  );
};

// Validações específicas por tipo de campanha
export const getCampaignValidationRules = (kind) => {
  const rules = {
    'offer': {
      requiresProducts: true,
      requiresCustomers: true,
      allowsDiscount: true,
      allowsImages: true
    },
    'reactivation': {
      requiresProducts: false,
      requiresCustomers: false,
      allowsDiscount: false,
      allowsImages: true
    },
    'activation': {
      requiresProducts: false,
      requiresCustomers: false,
      allowsDiscount: false,
      allowsImages: true
    },
    'follow_up': {
      requiresProducts: false,
      requiresCustomers: true,
      allowsDiscount: false,
      allowsImages: true,
      requiresObjective: true
    }
  };
  
  return rules[kind] || {};
}; 